import { Component, Event, EventEmitter, Host, h, Method, Prop } from '@stencil/core'

@Component({
  tag: 'cr-modal',
  styleUrl: 'cr-modal.css',
  shadow: true,
})
export class CrModal {

  constructor() {
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  /**
   * Signals the closing of the modal.
   */
  @Event() modalclosed: EventEmitter<null>;

  /**
   * Signals the opening of the modal
   */
  @Event() modalopened: EventEmitter<null>;

  /**
   * The title of the modal
   */
  @Prop() public modalTitle: string;

  /**
   * Whether or not the modal is visible
   */
  @Prop({
    mutable: true,
    reflect: true
  }) public visible: boolean = false;

  /**
   * Displays the modal
   * @param {null}
   */
  @Method()
  async show() {
    this.visible = true;
    this.modalopened.emit();
  }

  /**
   * Hides the modal
   * @param {null}
   */
  @Method()
  async hide() {
    this.visible = false;
    this.modalclosed.emit();
  }

  render() {
    return (
      <Host>
        <div
          class={this.visible ? "wrapper visible" : "wrapper"}
          part="wrapper"
          onKeyUp={this.handleKeyUp}
        >
          <div class="modal" part="modal">
            <div class="header" part="header">
              <div class="title" part="title">{this.modalTitle}</div>
              <div class="header-controls">
                <slot name="header"></slot>
                <button
                  type="button"
                  class="close-control"
                  part="close-control"
                  onClick={this.hide}
                >
                  <cr-icon-xmark size="medium" />
                </button>
              </div>
            </div>
            <div class="main" part="main">
              <slot name="main"></slot>
            </div>
            <div class="footer" part="footer">
              <div class="footer-left">
                <slot name="footer-left"></slot>
              </div>
              <div class="footer-center">
                <slot name="footer-center"></slot>
              </div>
              <div class="footer-right">
                <slot name="footer-right"></slot>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }

  private handleKeyUp(e: KeyboardEvent) {
    if (e.code === 'Escape') {
      this.hide();
    }
  }

}
